export default function Footer() {

    return (
        <footer className="footer">
            <a href="https://fernandocarvalhodev.com">Desenvolvido por Fernando Carvalho - Rumo ao Hexa! </a>
        </footer>
    )
}